module.exports = __webpack_public_path__ + "img/activity4.4612b780.png";